import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import {
  AppLayout,
  SideNavigation,
  TopNavigation,
} from '@cloudscape-design/components';
import { useAuth } from '@features/auth';
import { BreadcrumbNav } from '@features/configs/components/BreadcrumbNav';

/**
 * Main navigable layout with Cloudscape AppLayout.
 * Includes top navigation (branding + sign out) and side navigation.
 *
 * Requirements: 1.7, 1.8
 */
export function NavigableLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const { handleSignOut, email } = useAuth();

  return (
    <>
      <TopNavigation
        identity={{
          href: '/',
          title: 'Connect Portal',
          logo: {
            src: '/tower-logo.svg',
            alt: 'Tower',
          },
        }}
        utilities={[
          {
            type: 'menu-dropdown',
            text: email ?? 'User',
            iconName: 'user-profile',
            items: [
              { id: 'signout', text: 'Sign out' },
            ],
            onItemClick: ({ detail }) => {
              if (detail.id === 'signout') {
                handleSignOut();
              }
            },
          },
        ]}
      />
      <AppLayout
        navigation={
          <SideNavigation
            activeHref={location.pathname}
            onFollow={(event) => {
              event.preventDefault();
              navigate(event.detail.href);
            }}
            items={[
              { type: 'link', text: 'Configurations', href: '/' },
              { type: 'link', text: 'Journey View', href: '/journey' },
              { type: 'link', text: 'Pending Deletions', href: '/pending-deletions' },
              { type: 'divider' },
              { type: 'link', text: 'Bulk Upload', href: '/configs/new?mode=bulk' },
            ]}
          />
        }
        content={<><BreadcrumbNav /><Outlet /></>}
        toolsHide
      />
    </>
  );
}
